/* eslint-disable max-statements */
/* eslint-disable complexity */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import loadable from "@loadable/component";
import PostInspectionDiyPriceDiscovery from "../post-inspection-diy-price-discovery";
import PostInspectionDiyStartDocumentation from "../post-inspection-diy-start-documentation";
import { isAuctionOver } from "../post-inspection-diy/selector";
import { SCREEN_TYPES } from "../post-inspection-diy/constant";
import { PRICE_DISCOVERY } from "../../../constants/seller-diy-constants";
import { InView } from "react-intersection-observer";
import { NUMBER } from "../../../constants/app-constants";
import parseCookie from "../../../utils/helpers/parse-cookie";
import { TAB_NAMES } from "../post-inspection-diy-header-v2/constant";
import { REPORT_STATUS } from "../post-inspection-diy-car-inspection/constant";
import VideoPlayer from "../video-player";
import { sendCustomGaEvents } from "../../../tracking";
import { chrBannerViewed, videoBufferError, videoFullScreen, videoPause, videoPlay, videoTimeWatched } from "./tracking";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
// import { PACKAGE_TYPES_MAP_V2 } from "../../../constants/seller-package-constants";
import { SELLER_PACKAGE_CARD_CMS_NAME } from "./constant";
import PostDiySellerPackageCard from "../post-diy-seller-package-card";

const PostInspectionDiyCampaign = loadable(() => import("../post-inspection-diy-campaign"));
const PostInspectionDiySelfNego = loadable(() => import("../post-inspection-diy-self-nego"));
const PostInspectionDiyVideoSteps = loadable(() => import("../post-inspection-diy-video-steps"));
const PostInspectionDiyPriceSwipeHelper = loadable(() => import("../post-inspection-diy-price-swipe-helper"));
// const PostInspectionDiyCarHealthReportBanner = loadable(() => import("../post-inspection-diy-car-health-report-banner"));
// const PostInspectionDiyCarHealthPopup = loadable(() => import("../post-inspection-diy-car-health-popup"));

const PostInspectionDiyPriceTab = ({
    handleStartDocumentation,
    inspectionResponse,
    auctionResponse,
    setHammerSwipeConnect,
    setActiveTabConnect,
    helperVideos = [],
    // handleCarHealthDetails,
    carHealth,
    userId = "",
    handleSwitch = () => {},
    priceBreakup = {},
    getPartyPeshiVideoConnect = () => { },
    // hideCHRBanner,
    sellerPackageCmsData = [],
    onSellerPackageCardClick = () => {},
    children
}) => {
    const { reportData = {}, sellerPackageDetails } = carHealth || {};
    const { isSellerPackageEligible } = sellerPackageDetails || {};
    const { amount: carHealthAmount, status: carHealthStatus, cohortId = null  } = reportData || { };
    const {
        priceDiscovery,
        allowPllIntent,
        screen,
        isAuctionNotStarted = false,
        isSelfNegoFlowActive = false,
        // leadToken,
        isDocbFlowActive = false,
        isGSFlowActive = false,
        appointmentId = "",
        featureData = {},
        flowData = {},
        token
    } = inspectionResponse || {};
    const { offeredPrice, isExpired } = auctionResponse || {};
    const { dnpPriceConfirmationEnabled = false } = featureData || {};
    const { applicableFlows = [] } = flowData || {};
    const { videoLinks = [] } = priceBreakup || {};
    const priceHelper = parseCookie("diy_swipe_helper");
    const isDocbContextShown = parseCookie("docb_context");
    const [showSwipeHelper, setShowSwipeHelper] = useState(!priceHelper);
    // const carHealthViewed = parseCookie("car_health_view");
    // const isReportNotBought = carHealthStatus === REPORT_STATUS.NOT_BOUGHT && !hideCHRBanner;
    const [partyPeshiVideo, setPartyPeshiVideo] = useState(null);
    const { isApplicable, videoUrl } = partyPeshiVideo || {};

    const showCampaign = isAuctionOver(priceDiscovery) && (isExpired || !offeredPrice) && allowPllIntent;
    const isRepeatUser = screen === SCREEN_TYPES.REPEAT_USER && priceDiscovery === PRICE_DISCOVERY.NOT_STARTED;
    const sellerPackageSection = sellerPackageCmsData?.find(item => item.pageSection?.name === SELLER_PACKAGE_CARD_CMS_NAME)?.pageSection;

    useEffect(() => {
        if (!isDocbContextShown && isDocbFlowActive) {
            setActiveTabConnect(TAB_NAMES.DOCB_CONTEXT);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isDocbFlowActive]);

    useEffect(() => {
        if (priceDiscovery === PRICE_DISCOVERY.START && !partyPeshiVideo) {
            getPartyPeshiVideoConnect(token)
                .then((res) => setPartyPeshiVideo(res));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (carHealthStatus === REPORT_STATUS.NOT_BOUGHT) {
            sendCustomGaEvents({
                ...chrBannerViewed,
                eventLabel: `${appointmentId} | ${userId}`,
                ...(cohortId && {vas_chr_cohort: cohortId}),
                ...(carHealthAmount && {chr_price: carHealthAmount})
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [carHealthStatus]);

    const handleGaEvent = (event) => {
        sendCustomGaEvents({
            eventLabel: `${appointmentId}`,
            ...event
        });
    };

    useEffect(() => {
        const handleFullscreenChange = () => {
            if (document.fullscreenElement) handleGaEvent(videoFullScreen);
        };

        document.addEventListener("fullscreenchange", handleFullscreenChange);

        return () => document.removeEventListener("fullscreenchange", handleFullscreenChange);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if ((isSelfNegoFlowActive || isDocbFlowActive || isGSFlowActive) && !dnpPriceConfirmationEnabled) {
        return (
            <PostInspectionDiySelfNego
                applicableFlows={applicableFlows}
                handleSwitch={handleSwitch}
                children={children}
                sellerPackageSection={sellerPackageSection}
                onSellerPackageCardClick={onSellerPackageCardClick}
            />);
    }

    if (showCampaign && !isRepeatUser && !isAuctionNotStarted) {
        return (
            <div styleName={"styles.campaignWrapper"}>
                <PostInspectionDiyCampaign />
            </div>
        );
    }

    const handleInViewChange = (inView) => {
        setHammerSwipeConnect(!inView);
    };

    const onProgress = async (played) => {
        const progress = Number(played.toFixed(NUMBER.TWO)) * NUMBER.HUNDRED;
        if ([NUMBER.TEN,
            NUMBER.TWENTY_FIVE,
            NUMBER.FIFTY,
            NUMBER.SEVENTY_FIVE,
            NUMBER.NINETY,
            NUMBER.HUNDRED].includes(progress))  {
            await yieldToMain();

            handleGaEvent({
                ...videoTimeWatched,
                eventLabel: progress
            });
        }
    };

    return (
        <div styleName={"styles.postInspectionDiyPriceTab"}>
            { showSwipeHelper && <PostInspectionDiyPriceSwipeHelper
                setShowSwipeHelper={setShowSwipeHelper}
            /> }
            <PostInspectionDiyPriceDiscovery handleStartDocumentation={handleStartDocumentation}/>
            <PostInspectionDiyStartDocumentation handleStartDocumentation={handleStartDocumentation} />
            {
                isSellerPackageEligible &&
                <PostDiySellerPackageCard cardData={sellerPackageSection} onClick={onSellerPackageCardClick}/>
            }
            {helperVideos && !!helperVideos.length && <InView onChange={handleInViewChange} threshold={NUMBER.ONE} >
                <PostInspectionDiyVideoSteps heading= "What you need to do next?"/>
            </InView>}
            {((videoLinks && !!videoLinks.length) || isApplicable) &&
                <div styleName="styles.video">
                    <VideoPlayer
                        autoPlay={false}
                        url={isApplicable ? videoUrl : videoLinks[NUMBER.ZERO]}
                        controls={true}
                        width="100%"
                        height="100%"
                        progressInterval={1000}
                        playsinline={true}
                        onStart={() => handleGaEvent(videoPlay)}
                        onError={() => handleGaEvent(videoBufferError)}
                        onPause={() => handleGaEvent(videoPause)}
                        onProgress={({ played }) => onProgress(played)}
                    />
                </div>
            }
            {/* {isReportNotBought &&
                <PostInspectionDiyCarHealthReportBanner
                    leadToken={leadToken}
                    amount={carHealthAmount}
                    handleCarHealthDetails={handleCarHealthDetails}
                    cohortId={cohortId}
                />
            }
            { !carHealthViewed && isReportNotBought &&
                <PostInspectionDiyCarHealthPopup
                    leadToken={leadToken}
                    amount={carHealthAmount}
                    handleCarHealthDetails={handleCarHealthDetails}
                />
            } */}
        </div>
    );
};

PostInspectionDiyPriceTab.propTypes = {
    handleStartDocumentation: PropTypes.func,
    inspectionResponse: PropTypes.object,
    auctionResponse: PropTypes.object,
    setHammerSwipeConnect: PropTypes.func,
    setActiveTabConnect: PropTypes.func,
    helperVideos: PropTypes.array,
    handleCarHealthDetails: PropTypes.func,
    carHealth: PropTypes.object,
    userId: PropTypes.string,
    handleSwitch: PropTypes.func,
    priceBreakup: PropTypes.object,
    getPartyPeshiVideoConnect: PropTypes.func,
    hideCHRBanner: PropTypes.bool,
    sellerPackageCmsData: PropTypes.array,
    onSellerPackageCardClick: PropTypes.func,
    children: PropTypes.any
};

export default PostInspectionDiyPriceTab;
